import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {ParentService} from '../ParentClass/ParentService';
import {constant} from '../../../app.constants';
import {IActivateTripLiveMap, ILocationDriver} from './live-map-dispatch.interface';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {IDriverScheduleTrip} from '../../../core/interfaces/schedule-trip.interface';
import {IOsrmRoute} from '../../../core/interfaces/zones.interface';

@Injectable()
export class LiveMapDispatchService extends ParentService {

  private driverSelected = new BehaviorSubject<ILocationDriver>(undefined);
  driverSelected$ = this.driverSelected.asObservable();
  private tripSelected = new BehaviorSubject<IActivateTripLiveMap>(undefined);
  tripSelected$ = this.tripSelected.asObservable();
  private reload = new BehaviorSubject<boolean>(false);
  reload$ = this.reload.asObservable();
  private locationDriverSignalR = new BehaviorSubject<{ SignalR: any }>(undefined);
  locationDriverSignalR$ = this.locationDriverSignalR.asObservable();
  private statusTripSignalR = new BehaviorSubject<number[]>(undefined);
  statusTripSignalR$ = this.statusTripSignalR.asObservable();

  constructor(
    private http: Http,
  ) {
    super();
  }

  getLocationDrivers(companyId: number): Observable<ILocationDriver[]> {
    return this.http.get(`${constant.URL_LOCATION_DRIVERS}/${companyId}`, this.getHeader())
      .map(resp => resp.json());
  }

  setDriverSelected(data: ILocationDriver) {
    this.driverSelected.next(data);
  }

  setTripSelected(data: IActivateTripLiveMap) {
    this.tripSelected.next(data);
  }

  setReload(data: boolean) {
    this.reload.next(data);
  }

  setUpdateLocationDriverSignalR(eventSignalR: { SignalR: any }): void {
    this.locationDriverSignalR.next(eventSignalR);
  }

  setStatusTripSignalR(eventSignalR: number[]): void {
    this.statusTripSignalR.next(eventSignalR);
  }

  getDriverScheduleTrips(driverId: number, dateOfService: string): Observable<IDriverScheduleTrip[]> {
    return this.http.get(`${constant.URL_DRIVER_SCHEDULE_TRIPS}/${driverId}/${dateOfService}`, this.getHeader())
      .map(resp => resp.json());
  }

  getOsrmFullPath(path: {lat: number, lng: number}[]): Observable<IOsrmRoute> {
    let url = constant.URL_OSRM_ROUTE_DRIVING;
    path.forEach((item, i) => {
      url += `${(i === 0 ? '' : ';')}${item.lng},${item.lat}`;
    });
    return this.http.get(`${url}`)
      .map(resp => resp.json());
  }

  getActiveTrips(companyId: number): Observable<IActivateTripLiveMap[]> {
    return this.http.get(`${constant.URL_LIVE_MAP_DISPATCH_ACTIVE_TRIPS}/${companyId}`, this.getHeader())
      .map(resp => resp.json());
  }

  putTripDriverAndVehicle(data: {
    tripid: number;
    newdriverid: number;
    newvehicleid: number;
    olddriverid: number;
    oldvehicleid: number;
  }) {
    return this.http
      .put(constant.URL_EDIT_VEHICLE_DRIVER, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }





}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/live-map-dispatch/live-map-dispatch.service.ts